import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const templates = async () => {
  const response = await apiClient.request('GET', '/admin/templates');
  if (!isApiResponseError(response)) {
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw {
      ...validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE),
      field_names: response?.error?.field_names || [],
    };
  }
};

export const templateDetail = async (id) => {
  const response = await apiClient.request('GET', `/admin/templates/${id}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const templateDuplicate = async (id, data) => {
  const response = await apiClient.request('POST', `/admin/templates/${id}/make-duplicate`, data);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
